/**
 * Vite inlines `import.meta.env.VITE_*` at build time only for STATIC property
 * accesses, so read each one explicitly (never via a computed key).
 */
function readAuthApiUrl(): string {
  const raw = import.meta.env.VITE_AUTH_API_URL;
  if (!raw) {
    throw new Error(
      'VITE_AUTH_API_URL is not set — point it at api-auth (see .env.example)',
    );
  }
  return raw.replace(/\/+$/, '');
}

export const env = {
  /** Base URL of api-auth; equals the OIDC issuer. */
  get authApiUrl(): string {
    return readAuthApiUrl();
  },
};
